import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  currentFiltersContainer: {
    maxWidth: '75%',
    display: 'flex',
  },
  currentFilters: {
    overflowX: 'auto',
    display: 'flex',
  },
  filterChip: {
    marginRight: '8px',
    padding: '8px 8px',
    fontSize: '0.75rem',
    borderRadius: '2px',
    backgroundColor: '#E5E7ED',
    color: '#333',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  filterChipCloseIcon: {
    marginLeft: '8px',
    display: 'flex',
    cursor: 'pointer',
    color: '#333',
  },
  btnClearFilters: {
    boxShadow: 'unset !important',
    background: 'transparent !important',
    color: '#1891F6 !important',
    whiteSpace: 'nowrap',
    marginLeft: '8px',
  },
  iconResetFilter: {
    height: '12px !important',
    marginRight: '6px',
  },
}));